module.exports = __webpack_public_path__ + "img/colorLogo_active.51e8863d.svg";